/* eslint-disable max-len */
import { Component, Element, h, Prop, Method } from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

@Component({
  tag: 'ui-iframe',
  styleUrl: 'ui-iframe.scss',
  shadow: true,
})
export class UiIframe {
  @Element() el: HTMLElement;

  /**
   * Specifies the address of the document to embed in the `<iframe>`
   */
  @Prop() src: string;

  /**
   * Specifies the height of an `<iframe>` and is measured in pixels
   */
  @Prop() height: number;

  /**
   * Allow autoresize to work
   */
  @Prop() isAutoResized: boolean;

  @Prop() isLowestElementActivated: boolean;

  @Prop() isStrechtedOnNarrowViewport: boolean;

  @Prop() isHiddenOnNarrowViewport: boolean;

  @Prop() textOnHide: string;

  /**
   * Set to true if the <iframe> can activate fullscreen mode by calling the requestFullscreen() method
   */
  @Prop() allowFullScreen: boolean;

  iframe: HTMLIFrameElement;

  videoId: string;

  /**
   * @param message e any message to be sent into the iframe
   * @description Send a message to the iframe
   * @example this.postMessageIntoIframe({ name: 'doSomething'; type: 'play' });
   */
  @Method() postMessageIntoIframe(message: any) {
    this.iframe.contentWindow.postMessage(message, '*');
  }

  componentDidLoad() {
    this.videoId = this.getVideoIdFromSrc();
    if (this.isAutoResized) {
      window.ui.services.iframe.initResizer(
        {
          log: false,
          heightCalculationMethod: this.isLowestElementActivated
            ? 'lowestElement'
            : 'bodyOffset',
        },
        this.iframe
      );
    }
  }

  private getVideoIdFromSrc = () =>
    new URL(this.src)?.searchParams?.get('video-id');

  render() {
    const iframeClass = this.isHiddenOnNarrowViewport
      ? 'iframe iframe--hidden'
      : 'iframe';
    return (
      <div class={iframeClass}>
        <div class="iframe__wrapper">
          <iframe
            src={this.src}
            ref={(el) => {
              this.iframe = el;
            }}
            width="100%"
            height={`${this.height}px` || '600px'}
            allowFullScreen={this.allowFullScreen}
          ></iframe>
        </div>
        <p class="iframe__hiddentext">{this.textOnHide}</p>
      </div>
    );
  }
}

versionComponent(UiIframe);
